export default __webpack_public_path__ + "static/Note-taking apps-51a9a478895be8c0f3fb999c4b916e4e.svg";